/**
 * @summary this call will update the state if a request gets a response from a different source
 * @example fetch request to create user has no response but there is a socket message with a response
 * @param {Object} state redux state
 * @param {string} request the name of the request that was previously completed
 */
const finishRequest = (state, request) => {
  if (state[request]) {
    return {
      ...state,
      [request]: {
        ...state[request],
        pending: false,
      },
    }
  }
  return state
}

const customHandlers = {
  ['WEBSOCKET_DATA_users_createuser']: (state, action) =>
    finishRequest(state, 'API_REQUEST_users_add'),
}

/**
 * @summary match the action's type ending to a suffix type for the current state of the request
 * merge the action without the suffix into state to represent the MOST RECENT request data of that action type.
 */
const reducer = (state = {}, action) => {
  const requestHandlerSuffixes = [
    '_FETCH_REQUEST',
    '_FETCH_SUCCESS',
    '_FETCH_ERROR',
    '_FETCH_RESPONSE',
    '.resolve',
    '.start',
    // a bus request that errors has to stop being pending, the same way a
    // _FETCH_ERROR does -- without this the request stays pending forever and
    // whatever it gates (a loader, a disabled control) never comes back
    '.error'
  ]
  let matchedSuffix
  for (let i = 0; i < requestHandlerSuffixes.length; i++) {
    const suffix = requestHandlerSuffixes[i]
    if (action.type.endsWith(suffix)) {
      matchedSuffix = suffix
      break
    }
  }
  if (!matchedSuffix) {
    // check for any one off handlers
    if (customHandlers[action.type]) {
      return customHandlers[action.type](state, action)
    }
    // action isn't related to requests
    return state
  }
  const key = action.type.substring(0, action.type.length - matchedSuffix.length)
  if (
    matchedSuffix === '_FETCH_REQUEST' ||
    matchedSuffix === 'FETCH_RESPONSE' ||
    matchedSuffix === '.start' ||
    (state[key] && state[key].requestID === action.payload.requestID)
  ) {
    return {
      ...state,
      // will hold an object with the requestID passed in and a pending flag depending on the action type
      // example: NEW_EVENT_ITEM_2020061013: {mostRecentRequest}
      [key]: {
        requestID: action.payload.requestID,
        pending: matchedSuffix === '_FETCH_REQUEST' || matchedSuffix === '.start' || matchedSuffix === 'FETCH_RESPONSE',
        ...action.payload,
      },
    }
  } else {
    // was a request but it isn't related to the most recent request so it will be ignored
    return state
  }
}

export default reducer
